import * as classNames from "classnames";
import * as React from "react";
import { Box } from "signoxe/components/layout";
import {
  Button,
  FilterBar,
  FilterDropdown,
  Icon,
  Switch,
} from "signoxe/components/widgets";
import { ITag } from "signoxe/types";

import "./styles.scss";

const SearchBar: React.SFC<ISearchBarProps> = ({
  filterBarVisible,
  queryString,
  onQueryChange,
  togg,
  resumClick,
  onToggleFilterBar,
  toggleFilter,
  placeholder,
  hideSides,
  className

  
  
}) => (
  <div className={classNames('input-group 2.6.2 SearchBar', className)}
  >
    {!placeholder &&<input

      type="text"
      placeholder="Search assets"
      className="input-group-field"

      defaultValue={queryString}
      onChange={(event) => onQueryChange(event.target.value)}
    />}
    {placeholder &&<input
    
    type="text"
    placeholder={placeholder}
    className="input-group-field"
    defaultValue={queryString}
    onChange={(event) => onQueryChange(event.target.value)}
  />}
    <span className="input-group-label">
      <Icon title="Search" name="search" size="1rem" />
    </span>
    <Box direction="row" alignItems="center" className="resumable small">
      {/* <span className="label secondary">Resumable Upload:</span> */}
      <div style={{ marginLeft: "10px" }} onClick={resumClick}>
        {/* <Switch checked={!togg} /> */}
      </div>
    </Box>
  </div>
);

interface ISearchBarProps {
  filterBarVisible: boolean;
  hideSides: boolean;
  queryString: string;
  onQueryChange: (query: string) => void;
  onToggleFilterBar: () => void;
  togg: boolean;
  resumClick: () => void;
  toggleFilter: () => void;
  placeholder:string;
  className?: string;

  
}

const SearchFilterBar: React.SFC<ISearchFilterBarProps> = ({
  filterByType,
  filterByAspect,
  filterBarVisible,
  queryString,
  tags,
  onQueryChange,
  onFilterChange,
  onToggleFilterBar,
  resumClick,
  togg,
  toggleFilter,
  placeholder,
  hideSides,
className
}) => (
  <SearchBar
    hideSides={hideSides}
    queryString={queryString}
    filterBarVisible={filterBarVisible}
    onQueryChange={onQueryChange}
    onToggleFilterBar={onToggleFilterBar}
    resumClick={resumClick}
    togg={togg}
    toggleFilter={toggleFilter}
    placeholder={placeholder}
    className={className}
  />
  // {filterBarVisible && (
  //   <FilterBar
  //     filterByType={filterByType}
  //     tags={tags}
  //     filterByAspect={filterByAspect}
  //     onFilterChange={onFilterChange}
  //   />
  // )}
);

interface ISearchFilterBarProps {
  hideSides: boolean;
  filterByType: string;
  filterByAspect: string;
  filterBarVisible: boolean;
  queryString: string;
  tags: ITag[];
  onQueryChange: (query: string) => void;
  onFilterChange: (filterOn: string, filter: string) => void;
  onToggleFilterBar: () => void;
  togg: boolean;
  resumClick: () => void;
  toggleFilter: () => void;
  placeholder:string;
  className?: string;

}

export default SearchFilterBar;



// WEBPACK FOOTER //
// ./src/components/widgets/SearchFilterBar/index.tsx